import React from 'react';
import ApiCustomer from '../code/api/ApiCustomer';
import { SelectedMessageType } from '../code/enums/Enums';
import AddLogModel from '../code/models/AddLogModel';
import AuthAdminUserModel from '../code/models/AuthAdminUserModel';
import Customer from '../code/models/Customer';
import '../css/messagingaddlog.css';
import Toaster from "./Toaster";

interface IMessagingAddLog {
  currentUser: AuthAdminUserModel;
  customer: Customer;
}

export default function MessagingAddLog({ currentUser, customer }: IMessagingAddLog) {
  const [selectedType, setSelectedType] = React.useState<SelectedMessageType>(SelectedMessageType.InboundCall);
  const [toastMessage, setToastMessage] = React.useState<string>("");
  const subjectRef = React.useRef<HTMLInputElement>();
  const messageRef = React.useRef<HTMLTextAreaElement>();

  function handleMessageTypeChange(messageType: SelectedMessageType) {
    setSelectedType(messageType);
    let subject = "";
    switch (messageType) {
      case SelectedMessageType.EmailSent:
        subject = "Email Sent";
        break;
      case SelectedMessageType.GeneralComment:
        subject = "General Comment";
        break;
      case SelectedMessageType.InboundCall:
        subject = "Inbound Call";
        break;
      case SelectedMessageType.OutboundCall:
        subject = "Outbound Call";
        break;
    }

    if (!!subjectRef.current) {
      subjectRef.current.value = subject;
      subjectRef.current.focus();
    }
  }

  function validate() {
    return subjectRef.current &&
      subjectRef.current.value &&
      subjectRef.current.value.length > 0 &&
      messageRef.current &&
      messageRef.current.value &&
      messageRef.current.value.length > 0;
  }

  function handleAddLogClick() {
    if (validate()) {
      const dataContract: AddLogModel = {
        "adminId": currentUser.id,
        "customerId": customer.customerId,
        "logTypeId": selectedType,
        "subject": subjectRef.current?.value || "",
        "message": messageRef.current?.value || ""
      };

      ApiCustomer.addLog(dataContract).then(data => {
        showLogAddedToast(data.customerLogId);
        if (subjectRef.current && messageRef.current) {
          subjectRef.current.value = "";
          messageRef.current.value = "";
        }
      });
    } else {
      showMissingFieldsToast();
    }
  }

  function showMissingFieldsToast() {
    setToastMessage("Fill in all fields to add a log.");
    setTimeout(() => { setToastMessage(""); }, 4000);
  }

  function showLogAddedToast(id: number) {
    setToastMessage(`The log message has been added to the customer. (${id})`);
  }

  return (
    <React.Fragment>
      <form className='container messaging-addlog-div'>
        <div className='w-75 messaging-addlog-buttons'>
          <div className="form-check form-check-inline">
            <input className="form-check-input" type="radio" name="messageType" id="inboundCallRadio"
              checked={selectedType === SelectedMessageType.InboundCall}
              onClick={() => handleMessageTypeChange(SelectedMessageType.InboundCall)}
              onChange={() => { }} />
            <label className="form-check-label" htmlFor="inboundCallRadio">
              Inbound Call
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input className="form-check-input" type="radio" name="messageType" id="outboundCallRadio"
              checked={selectedType === SelectedMessageType.OutboundCall}
              onClick={() => handleMessageTypeChange(SelectedMessageType.OutboundCall)}
              onChange={() => { }} />
            <label className="form-check-label" htmlFor="outboundCallRadio">
              Outbound Call
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input className="form-check-input" type="radio" name="messageType" id="emailSentRadio"
              checked={selectedType === SelectedMessageType.EmailSent}
              onClick={() => handleMessageTypeChange(SelectedMessageType.EmailSent)}
              onChange={() => { }} />
            <label className="form-check-label" htmlFor="emailSentRadio">
              Email Sent
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input className="form-check-input" type="radio" name="messageType" id="generalCommentRadio"
              checked={selectedType === SelectedMessageType.GeneralComment}
              onClick={() => handleMessageTypeChange(SelectedMessageType.GeneralComment)}
              onChange={() => { }} />
            <label className="form-check-label" htmlFor="generalCommentRadio">
              General Comment
            </label>
          </div>
          <div className="messaging-addlog-subject mb-3">
            <label htmlFor="messageSubject" className="form-label">Subject</label>
            <input id="messageSubject" type="text" className="form-control" placeholder="enter subject here"
              ref={subjectRef as React.RefObject<HTMLInputElement>} defaultValue="Inbound Call"
              onFocus={(e) => { e.target.select(); }} />
          </div>
          <div className="mb-3">
            <label htmlFor="messageTextarea" className="form-label">Message</label>
            <textarea className="form-control" id="exampleFormControlTextarea1" rows={10}
              ref={messageRef as React.RefObject<HTMLTextAreaElement>}></textarea>
          </div>
          <div className="mb-3">
            <input type="button" value="Add Log" className="btn btn-outline-primary form-button" onClick={handleAddLogClick} />
          </div>
        </div>
      </form>
      <Toaster title={"Customer Log"} subtitle={""} message={toastMessage} />
    </React.Fragment>
  )
}
